<template>
<div class="index" id="home" :style="{paddingTop: $store.state.headerHeight + 'px'}" v-loading="pageLoading">
  <SubHeader :showUser="true" :showNav="false"></SubHeader>
  
  <div class="index-vip" v-if="plat!=120 && !vipInfo.is_buy" v-show="false" @click="toVIP">
    <!-- 不是会员1 -->
    <div class="btn">
        开通会员
      </div>
  </div>
  <div class="index-vip2" v-else-if="plat != 120" v-show="false"  @click="toVIP">
    <!-- 是会员 -->
    <div class="content">
      <b>尊敬的会员用户</b>
      您的会员有效期到{{vipInfo.end_time}}
    </div>

      <div class="btn">
        立即续费
      </div>
  </div>
  <van-swipe class="my-swipe2" :autoplay="3000" indicator-color="black" :show-indicators="true" v-if="swiperData.length">
    <van-swipe-item v-for="item in swiperData" :key="item.id">
      <img :src="item.cover" @click="goDetail(item.url)"/>
    </van-swipe-item>
  </van-swipe>
  <h3>VIP课程</h3>
  <div class="level" v-if="item.list.length" v-for="item in category" :key="item.id">
    <div class="part-titleYingyou part-title2" v-if="!pageLoading">
      <div class="part-title_text part-title_text2">{{item.name}}</div>
      <p @click="toVIPList(item.id)">查看更多 <van-icon name="arrow" size="12" color="#000"/></p>
    </div>
      <!-- <div class="tabList">
          <p :class="{active:yyList2Index==index}" v-for="(item, index) in yyList2" @click="yyList2Index = index">{{ item.name }}</p>
      </div> -->
      <PriceCard v-for="(v, i) of item.list"  :key="i"   @click.native="goDetail(v.id)" :index="v.id" :cardData="v"></PriceCard>
  </div>
  <!-- 职业认证 -->
  <div class="quality" v-if="jnLesson && jnLesson.list && jnLesson.list.length">
    <div class="part-titleYingyou part-title2" v-if="!pageLoading">
      <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E6%8E%A8%E8%8D%90%402x.png"/>
      <div class="part-title_text">职业能力认证</div>
      <p @click="toList(jnLesson.id)">查看更多 <van-icon name="arrow" size="12" color="#231815"/></p>
    </div>
    <div class="list12">
      <div v-for="(item, index) of jnLesson.list" :key="index" >
        <PriceCardjn :index="index" :cardData="item"  @click.native="goDetail(item.id)" type="demonstrate"></PriceCardjn>
      </div>
    </div>
    <div class="line"></div>
  </div>
  
  <!-- <div class="level" v-if="yyList3.length">
    <div class="part-titleYingyou part-title2" v-if="!pageLoading">
      <div class="part-title_text">{{yyList3Name}}</div>
      <p @click="toList(174)">查看更多 <van-icon name="arrow" size="12" color="#000"/></p>
    </div>
    <div class="tabList">
          <p :class="{active:yyList3Index==index}" v-for="(item, index) in yyList3" @click="yyList3Index = index">{{ item.name }}</p>
      </div>
      <PriceCard v-for="(v, i) of yyList3[yyList3Index].list[0].slice(0,3)"  :key="i"   @click.native="goDetail(v.id)" :index="yyList3Index" :cardData="v"></PriceCard>
  </div> -->
 
  <div class="live" style="padding-bottom:20px" v-if="liveData.length">
    <div class="part-titleYingyou" v-if="!pageLoading">
      <div class="part-title_text">直播专栏</div>
      <div class="part-title_more" @click="goList('live')">查看更多></div>
    </div>
    <div class="hot-list">
      <LiveCard v-for="(item, index) of liveData" :key="index" :index="index" :cardData= "item"></LiveCard>
    </div>
  </div>
  
  <div class="bottom">—   到底了…  —</div>
  <!-- <sub-footer :top="top" @toTop="toTop"></sub-footer> -->
  <img 
    class="topImg" v-if="top<0" @click="toTop"
    src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E5%9B%9E%E5%88%B0%E9%A1%B6%E9%83%A8%402x.png"/>
</div>
</template>

<script>
import PriceCard from "@/components/PriceCardYingyou";
import PriceCardjn from "@/components/PriceCard1-3";
import PriceCardImgBig from "@/components/PriceCardImgBigYingyou";
import VideoCard from "@/components/VideoCard";
import TopCard from "@/components/TopCard";
import SubHeader from "@/components/SubHeaderYingyou";
import SubFooter from "@/components/YingyouTab";
import LiveCard from "@/components/LiveCard";
import ideaList from "@/components/ideaList";
import { resolve } from "path";
import { Toast } from "vant";
import { timingSafeEqual } from "crypto";

// import Vue from 'vue'
// import VConsole from 'vconsole';
// Vue.prototype.Vconsole = new VConsole()

export default {
  components: {
    PriceCard,
    PriceCardjn,
    VideoCard,
    TopCard,
    SubHeader,
    SubFooter,
    LiveCard,
    PriceCardImgBig,
    ideaList
  },
  computed: {
    titleName() {
      return this.$store.state.plat.name;
    },
    plat() {
      return this.$store.state.plat_id;
    },
    indexTab() {
      return this.$store.state.indexTab2;
    },
  },
  data() {
    return {
      tabActive: "index",
      active: 0,
      pageLoading: true,
      listLoading: false,
      swiperData: [],
      category: [],
      gpLesson: [],
      jnLesson: [],
      liveData: [],
      vipInfo:{},
   
      demonstrate:[],
      top:0,
    };
  },
  async mounted() {
    this.init();
    this.handleScrollToc()
    window.addEventListener("scroll", this.handleScrollToc, true);
  },
  beforeDestroy(){
    console.log('destory')
    window.removeEventListener("scroll", this.handleScrollToc, true);
  },
  methods: {
    toTop(){
      let timer = setInterval(()=>{
        document.documentElement.scrollTop = document.documentElement.scrollTop>=20 ? document.documentElement.scrollTop-20 : 0
        if(document.documentElement.scrollTop<=0){
          clearInterval(timer)
        }
      },10)
      
    },
    handleScrollToc() {
      let info = document.getElementById("home").getBoundingClientRect();
      this.top = info.top;

    },
    will() {
      this.$toast('敬请期待');
    },
    change(event) {
      this.current = event.detail.current;
    },
    
    async init() {
      if(this.$until.isWeiXin()=='wxapp' && this.$route.query.phone){
        // alert('phone:'+this.$route.query.phone)
        await this.$request.mobileLogin({
            mobile:this.$route.query.phone
          })
      }
      // this.$toast.loading({
      //   message: '加载中...',
      //   forbidClick: true,
      // });
      let res = await this.$request.jiazhangIndex( {
          flat_id: this.plat,
          is_interior: 2,
          terminal: 1, //1 pc 2 小程序
        },);
      // this.$toast.clear();
      this.pageLoading = false
      if (res.code == 0) {
        let catList = []
        res.data.category_list.slice(0,2).forEach(item=>{
           catList.push({
            name:item.name,
            id:item.id,
            list:item.list.filter(v=>  v.list[0].length).map(vv=>vv.list[0]).flat().slice(0,4)
          })
        })
        this.category = catList;
        this.liveData = res.data.live_stream ? res.data.live_stream.filter(v=>  v.data.length).map(vv=>vv.data).flat().slice(0,4) : [];
        let jnLesson = []
        if(res.data.category_list && res.data.category_list.length>2){
          res.data.category_list.slice(2,3).forEach(item=>{
            jnLesson.push({
              name:item.name,
              id:item.id,
              list:item.list.filter(v=>  v.list[0].length).map(vv=>vv.list[0]).flat().slice(0,4)
            })
          })
        }
        this.jnLesson = jnLesson[0] ? jnLesson[0] : {};
        console.log(this.jnLesson)
        this.swiperData = res.data.banner || [];
        this.$store.commit('SET_VIP',res.data.plat_vip)
      } else {
        this.$toast(res.msg);
      }
    },
    jumpUser() {},
    async getUser() {
      let res = await this.$api({
        url: "/api/auth/me",
      });
      if (res.code == 0) {
        this.$store.commit("setUser", res.data);
      }
    },
    toPage(url){
      if(url) window.location.href = url
    },
    goDetail(id) {
      let url = `./detailYingyou?id=${id}`
     
      this.$router.push(url);
    },
    goLiveDetail(item) {
      let {
        name,
        video_url,
        host,
        img_url,
        category_name,
        video_id,
        ccid,
        cover,
        id
      } = item;
      let videoId = video_id;
      let type = 'aliyun'
      if (ccid) {
        id = ccid;
        type = 'cc';
      }
      if (video_url) {
        this.$router.push(`./LiveDetail?id=${id}&name=${name}&url=${video_url}&host=${host}&cover=${img_url}&category_name=${category_name}`);
      } else if(videoId){
        this.$router.push(`./LiveDetail?id=${id}&name=${name}&videoId=${videoId}&type=${type}&cover=${cover}`);

      } else {
        this.$toast('没有视频')
      }

    },
    toList(id){
      this.$router.push(`./lessonYingyou?id=${id}`);
    },
    toVIPList(id){
      this.$router.push(`./vipLesson?id2=${id}`);
    },
    goList(type) {
      this.$router.push(`./${type}`);
    },
    goProductList(index) {
      if (this.plat == 118 || this.plat == 119) {
        this.will();
      } else {
        this.$router.push(`./lesson?index=${index}`);
      }
    },
    toVIP(){
      if(!localStorage.getItem('token')){
        this.$dialog.confirm({
          title: '提示',
          message: '请登录后查看',
          confirmButtonText:'立即登录',
        })
          .then(() => {
            // on confirm
            this.$router.push('./login/phone')
          })
          .catch(() => {
            // on cancel
          });
      }else{
        this.$router.push({
          path:'./vip/detailVIP',
          query:{
            id:this.vipInfo.goods_id
          }
        })
      }
    }
  },
};
</script>

<style lang="scss">
.topImg{
  position: fixed;
  z-index: 110;
  right: 50px;
  bottom: 50px;
  width: 80px;
  height: 80px;
}
  .my-swipe2{
    width: 690px;
    margin: 30px auto 0;
    img{
      width: 100%;
      border-radius: 10px;
    }
  }
  .index-vip {
    width: 690px;
    height: 172px;
    margin: 23px auto 18px;
    display: block;
    background: url('https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/vip.png') no-repeat;
    background-size: 100%;
    position: relative;
  }
 
  .index-vip2 {
    width: 690px;
    height: 172px;
    margin: 23px auto 18px;
    display: block;
    background: url('https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/isVipBg.png') no-repeat;
    background-size: 100%;
    position: relative;
  }
  .index-vip2 .content{
  position: absolute;
  left:30px;
  top:40px;
  color: #6a4a2c;
  font-size: 24px;
}
.index-vip2 .content b{
  display: block;
  font-weight: bold;
  font-size: 34px;
  margin-bottom: 15px;
}
.index-vip
 .btn, .index-vip2 .btn {
  position: absolute;
  bottom: 37px;
  right: 37px;
  width: 155px;
  height: 56px;
  background: #6a4a2c;
  border-radius: 28px;
  text-align: center;
  line-height: 56px;
  color: #fff;
  font-size: 26px;
}
.index {
  min-height: 100vh;
  overflow: hidden;
  // padding-bottom: 2rem;
  background: #f9f9f9;
  padding-top: 100px;
  box-sizing: border-box;
}
.part-titleYingyou{
  display: flex;
  align-items: center;
  padding: 60px 30px 30px;
  >img{
    width: 36px;
    margin-right: 10px;
  }
  .part-title_text{
    flex: 1;
    font-weight: 500;
    color: #000000;
    font-size: 36px;
  }
  p{
    color: #999;
    font-size: 24px;
  }
}
.level{
  >b{
    font-size: 30px;
    padding: 0 0.4rem 0.2rem;
    display: block;
  }
}
.tabList{
  padding-top: 10px;
  padding-left: 30px;
  margin-bottom: 36px;
  box-sizing: border-box;
  width: 100%;
  white-space: nowrap;
  overflow-x: scroll;
  &::-webkit-scrollbar{
    height: 0 !important;
  }
 -ms-overflow-style: none;
 overflow: -moz-scrollbars-none;
  p{
    display: inline-block;
    padding: 0 16px;
    border-radius: 24px;
    height: 48px;
    line-height: 48px;
    background: #fff;
    margin-right: 20px;
    font-size: 24px;
    color: #666;
    font-weight: 400;
  }
  p.active{
    background-color: #F08E00;
    color: #fff;
  }
  
}
.sroll{
  padding-left: 30px;
  box-sizing: border-box;
  width: 100%;
  white-space: nowrap;
  overflow-x: scroll;
  &::-webkit-scrollbar{
    height: 0 !important;
  }
 -ms-overflow-style: none;
 overflow: -moz-scrollbars-none;
 .srollItem{
  display: inline-block;
  width: 70vw;
  margin-right: 20px;
 }
}
.quality {
  width: 100vw;

  .quality-list {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    .list13{
      flex: 1;
      margin-left: 20px;
      overflow: hidden;
      &:last-of-type{
        margin-right: 20px;
      }
    }
  }
  .list12{
    width: 100vw;
    padding: 0 30px;    
    >div{
      width: calc((100vw - 80px)*0.5);
      display: inline-block;
      &:nth-of-type(2n+1){
        margin-right: 20px;
      }
    }
  }
}
.bottom{
  font-size: 24px;
  font-weight: 400;
  color: #CCCCCC;
  line-height: 34px;
  text-align: center;
  padding-top: 40px;
  padding-bottom: 40px;
}
h3{
  padding: 40px 30px 20px;
  font-size: 36px;
  color: #333;
  font-weight: 600;
  margin: 0;
}
.part-title_text2{
  font-size: 32px !important;
}
.part-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  
}
.part-title2 {
  padding-top:25px
}

</style>
